import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useFlags } from 'wsm-common-data';

import CarflixVideoPlayer from './CarflixVideoPlayer';
import { isCarflixVideo } from '../helpers/videos';
import './DDCPlayerVideoComponent.scss';

const DDCPlayerVideoComponent = (props) => {
	const {
		video,
		viewportWidth,
		viewportHeight,
		widgetInfo,
		modalSettings,
		mobileOrientationIsPortrait
	} = props;
	const flags = useFlags();
	const toggleVideojs = (flags && flags['videojs-player-carflix']) || false;
	const useVideojs = toggleVideojs && isCarflixVideo(video);

	useEffect(() => {
		if (useVideojs) return;

		if (typeof DDC !== 'undefined') {
			if (
				video &&
				DDC.modules &&
				DDC.modules.video &&
				typeof $ !== 'undefined'
			) {
				/* eslint no-undef: 0 */
				$(document).trigger('modulesRefresh', DDC.modules.video);
			}
		}
		// Only run on mount, same as the previous componentDidMount
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [useVideojs]);

	if (video) {
		const { id, uri } = video;
		const { accountId, deviceType } = widgetInfo;
		const { videoIsOpen, modalIsOpen } = modalSettings;

		let videoWidth = viewportWidth < 920 ? viewportWidth : 920;
		if (!mobileOrientationIsPortrait && /mobile/gi.test(deviceType)) {
			videoWidth = viewportHeight;
		}

		const baseClassNames = [
			'h-100',
			'd-flex',
			'justify-content-center',
			'align-items-center'
		];
		const wrapperClassNames = new Set([
			...baseClassNames,
			...['video-container', 'py-5']
		]);
		const playerClassNames = [...baseClassNames, ...['ddcPlayer-holder']];

		if (!videoIsOpen) {
			wrapperClassNames.add('hide');
			wrapperClassNames.delete('d-flex');
		}

		if (useVideojs) {
			return (
				<div className={[...wrapperClassNames].join(' ')}>
					<CarflixVideoPlayer
						video={video}
						isVisible={Boolean(videoIsOpen) && modalIsOpen !== false}
						isModalOpen={modalIsOpen !== false}
					/>
				</div>
			);
		}

		return (
			<div className={[...wrapperClassNames].join(' ')}>
				<div
					id={`video-${id}`}
					className={playerClassNames.join(' ')}
					data-ddcplayerinfo={`${encodeURIComponent(
						uri
					)}-${videoWidth}-${Math.round(videoWidth * 0.7)}`}
					data-accountid={`${accountId}`}
					data-useprepostroll="false"
					data-autoplay="false"
				/>
			</div>
		);
	}

	// No video - nothing to see here
	return null;
};

DDCPlayerVideoComponent.propTypes = {
	widgetInfo: PropTypes.shape({
		accountId: PropTypes.string,
		deviceType: PropTypes.string
	}).isRequired,
	viewportWidth: PropTypes.number.isRequired,
	viewportHeight: PropTypes.number.isRequired,
	video: PropTypes.shape({
		id: PropTypes.number,
		uri: PropTypes.string,
		provider: PropTypes.string
	}),
	modalSettings: PropTypes.shape({
		videoIsOpen: PropTypes.bool,
		modalIsOpen: PropTypes.bool
	}).isRequired,
	mobileOrientationIsPortrait: PropTypes.bool.isRequired
};

DDCPlayerVideoComponent.defaultProps = {
	video: {}
};

export default DDCPlayerVideoComponent;
